module.exports = __webpack_public_path__ + "fonts/MyriadPro-Bold.a84c468.woff";